import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const CONTINUOUS_STEPS_TYPE = 'P360_Steps';

export const getDailyStepsAverage = (days) => {
    const recorded = days.filter((day) => day.steps > 0);
    return recorded.length
        ? recorded.reduce((sum, day) => sum + day.steps, 0) / recorded.length
        : null;
};

export const normalizeContinuousSteps = (
    table,
    { startTimestamp, endTimestamp, zone }
) => {
    const days = new Map();
    const start = Date.parse(startTimestamp);
    const end = Date.parse(endTimestamp);
    if (!Number.isFinite(start) || !Number.isFinite(end) || start >= end) return [];

    const columns = Array.isArray(table?.columns) ? table.columns : [];
    const timeIndex = columns.indexOf('ts');
    const stepsIndex = columns.indexOf('steps');
    for (const row of Array.isArray(table?.data) ? table.data : []) {
        if (
            timeIndex < 0 ||
            stepsIndex < 0 ||
            !Array.isArray(row) ||
            row.length !== columns.length
        )
            continue;
        const timestamp =
            typeof row[timeIndex] === 'string' ? Date.parse(row[timeIndex]) : NaN;
        const rawSteps = row[stepsIndex];
        if (
            !Number.isFinite(timestamp) ||
            timestamp < start ||
            timestamp >= end ||
            !['number', 'string'].includes(typeof rawSteps) ||
            String(rawSteps).trim() === ''
        )
            continue;
        const steps = Number(rawSteps);
        if (!Number.isSafeInteger(steps) || steps < 0) continue;
        const date = dayjs(timestamp).tz(zone).format('YYYY-MM-DD');
        const revision = timestamp;
        if (!days.has(date) || revision >= days.get(date).revision) {
            days.set(date, { steps, revision });
        }
    }

    const data = [];
    let date = dayjs(start).tz(zone).format('YYYY-MM-DD');
    while (dayjs.tz(date, zone).valueOf() < end) {
        data.push({ date, steps: days.get(date)?.steps ?? null });
        date = dayjs.utc(date).add(1, 'day').format('YYYY-MM-DD');
    }
    return data;
};
